import React, { useState, useEffect, useRef } from 'react';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';

import { styled } from '@mui/material/styles';
import '../zo-input-text/zo-input-text.scss';
import './zo-input-textarea.scss';

interface InputTextAreaProps {
  title?: string;

  required?: boolean;

  disabled?: boolean;

  placeholder?: string;

  value?: string | any;

  minRows?: number;

  maxRows?: number;

  ref?: any;
  charLimit?: number;
  // onBlur: (val: string) => void;
  onBlur?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => any;

  focusInput?: boolean;

  onFocus?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>
  ) => any;

  inputTextAreaStyle?: React.CSSProperties;

  containerStyles?: React.CSSProperties;

  inputFieldProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;

  inputTextAreaTitleStyle?: React.CSSProperties;

  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;

  hideResize?: boolean;

  constraintIndicator?: string;
}

const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 100%;
    font-size: 16px;
    padding: 8px;
    color: #000000;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    resize: vertical;
        
     &::placeholder {
      color: #BFC0C2;
      opacity: 1;
      fontSize: 14px;
      fontFamily: Segoe-UI-VF;
      fontWeight: 400;
    }
    &:hover {
      border-color: #000000;
    }
    &:focus {
      border-color: #33A7E8;
    }
    &:focus-visible {
      outline: 0;
    }
  `
);

export const ZoInputTextArea = ({
  title,
  placeholder = '',
  value,
  minRows,
  maxRows,
  ref,
  onBlur,
  focusInput = false,
  required = false,
  disabled = false,
  onFocus,
  inputTextAreaStyle,
  containerStyles,
  inputFieldProps,
  inputTextAreaTitleStyle,
  onChange = () => {},
  hideResize = false,
  constraintIndicator,
  charLimit,
}: InputTextAreaProps) => {
  if (!ref) {
    ref = useRef<HTMLInputElement>(null);
  }
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (focusInput) {
      ref?.current?.focus();
    } else {
      ref?.current?.blur();
    }
  }, [focusInput]);

  // const styleContainer = {
  //   height: '84px',
  //   ...inputTextAreaStyle,
  // };
  return (
    <div className="input_text_area font-regular">
      <div className="input_text_area__container">
        {title && (
          <span
            className={`input_text_area__title ${
              isFocused ? 'input_text_area__focused' : ''
            }`}
            style={{ ...inputTextAreaTitleStyle }}
          >
            {title}
            {required && <span className="input_text__asterisk">*</span>}
          </span>
        )}
        {constraintIndicator && (
          <span className="input_text_area__constraint font-regular">
            {constraintIndicator}
          </span>
        )}
      </div>
      <Textarea
        className="font-regular"
        // style={styleContainer}
        style={{
          ...inputTextAreaStyle,
          ...(hideResize ? { resize: 'none' } : {}),
        }}
        value={value}
        required={required}
        disabled={disabled}
        minRows={minRows}
        maxRows={maxRows}
        maxLength={charLimit}
        onFocus={(e) => {
          setIsFocused(true);
          onFocus && onFocus(e);
        }}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur && onBlur(e);
        }}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
        {...inputFieldProps}
      />
    </div>
  );
};
